module.exports = __webpack_public_path__ + "static/media/icon-callcenter.f80e145f.svg";